/**
 * @typedef {{
* id:string,
* dataLayer: object
* }} analyticsDataInterface
*
* @type {analyticsDataInterface[]}
*/

var BTN_ACOMPANHAR = document.getElementById('btn_acompanhar');
var BTN_VER_PLANOS = document.getElementById('btn_ver_planos');
var BTN_IR_PRO_BLOG = document.getElementById('btn_ir_pro_blog');
var BTN_SOLICITAR_MEU_CREDITO = document.getElementById('btn_solicitar_meu_credito');


BTN_ACOMPANHAR.addEventListener("click", (event) => {
	dataLayer.push({
		event: "banner_click",
		page_location: document.location.href,
		page_path: document.location.pathname,
		link_classes: event.target.className,
		link_domain: new URL(event.target.href).host,
		link_id: event.target.id,
		link_url: new URL(event.target.href).href,
		outbound: false
	})
})

BTN_VER_PLANOS.addEventListener("click", (event) => {
	dataLayer.push({
		event: "banner_click",
		page_location: document.location.href,
		page_path: document.location.pathname,
		link_classes: event.target.className,
		link_domain: new URL(event.target.href).host,
		link_id: event.target.id,
		link_url: new URL(event.target.href).href,
		outbound: false
	})
})

BTN_IR_PRO_BLOG.addEventListener("click", (event) => {
	dataLayer.push({
		event: "banner_click",
		page_location: document.location.href,
		page_path: document.location.pathname,
		link_classes: event.target.className,
		link_domain: new URL(event.target.href).host,
		link_id: event.target.id,
		link_url: new URL(event.target.href).href,
		outbound: false
	})
})

BTN_SOLICITAR_MEU_CREDITO.addEventListener("click", (event) => {
	dataLayer.push({
		event: 'form_click',
		page_location: document.location.href,
		page_path: document.location.pathname,
		link_classes: event.target.className,
		link_domain: document.location.host,
		link_id: event.target.id,
		link_url: document.location.href,
		outbound: false
	})
})


const analyticsData = [
	{
		id: 'buttonMenuOifibra',
		dataLayer: {
			teste: 'Botao Oi Fibra clicado',
			event: 'header_click',
			page_location: '<URL Inteira da pagina atual>',
			page_path: '<Parte da URL apos o https://www.oi.com.br/>',
			link_classes: '<Atributo HTML Class do botão>',
			link_domain:
				'<Domínio de destino de um link externo (preenchido pelo parâmetro “href”)>',
			link_id: '<Atributo HTML Id do botão>',
			link_url:
				'<URL completo de um link externo (preenchido pelo parâmetro “href”)>',
			outbound:
				'<Retornar “true” quando o botão direcionar para outro domínio. Quando não direcionar para outro domínio, retornar “false”>'
		}
	},
	
	{
		id: 'solicitarMeuCredito',
		dataLayer: {
			event: 'generate_lead',
			page_location: document.location.href,
			page_path: document.location.pathname,
			currency: "BRL",
			value: ""
		}
	},


];

/**
 * DOCS
 *
 */
